import 'js/src/libs/set-webpack-nonce';
import 'core-js/stable';
import 'js/src/libs/page-initialization';
import 'bootstrap';
import 'regenerator-runtime/runtime';

import 'css/src/global';

import React from 'react';
import { createRoot, hydrateRoot } from 'react-dom/client';

import { ErrorReporter, Project } from 'js/src/libs/error-reporter';
import type { ContentfulPageProps } from 'js/src/ssr/contentful-page-app';
import { ContentfulPageApp, prepareContentfulPage } from 'js/src/ssr/contentful-page-app';

ErrorReporter.init(Project.FRONTEND);

const PROPS_ELEMENT_ID = 'contentful-page-props';

function readProps(): ContentfulPageProps {
    const element = document.getElementById(PROPS_ELEMENT_ID);
    if (!element?.textContent) {
        throw new Error(`Could not find #${PROPS_ELEMENT_ID}`);
    }
    return JSON.parse(element.textContent) as ContentfulPageProps;
}

const content = prepareContentfulPage(readProps());

const container = document.getElementById('react-root');
if (!container) {
    throw new Error('Could not find #react-root element');
}

const app = <ContentfulPageApp content={content} />;

// Nothing to hydrate whenever server rendering is off or unavailable, which is a normal
// outcome rather than an error.
if (container.hasChildNodes()) {
    hydrateRoot(container, app);
} else {
    createRoot(container).render(app);
}
